export default () => {
  var $productTeasers = $('.js-apn-teaser-product');
  if ($productTeasers.length) {
    (function ($) {
      function loadProductTeaser($productTeaser) {
        var productId = $productTeaser.attr('data-product-id'),
          productPos = $productTeaser.data('productPos');

        if (productId && productPos) {
          if ($productTeaser.data('xhr') !== undefined) {
            $productTeaser.data('xhr').abort();
          }

          $productTeaser.html(
            $(
              '<div class="spinner-balls"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
            ),
          );
          var xhr = $.ajax({
            url: '/rpc.php?action=recommendation',
            method: 'GET',
            data: {
              ids: productId,
              pos: productPos,
              eleid: '0',
            },
            success: function (response) {
              var $innerHtml = $(response.html);
              $productTeaser.html($innerHtml);
              $productTeaser.trigger('productTeaser:loaded');
              addToBasketFunctions();
              addToLeafletFunctions();
              addJsDetailLink();
            },
            error: function (request, textStatus, errorThrown) {
              if (request.statusText !== 'abort') {
                $productTeaser.remove();
              }
            },
          });
          $productTeaser.data('xhr', xhr);
        }
      }

      $productTeasers.each(function () {
        var observer = new MutationObserver(function (mutations, observer) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'data-product-id') {
              loadProductTeaser($(mutation.target));
            }
          });
        });
        observer.observe(this, { attributes: true });
        loadProductTeaser($(this));
      });
    })(jQuery);
  }
};
